import API from '../api-service.js';
import axios from 'axios';
import moment from 'moment';
import content from '@/utils/shared/content-structure';

const baseUri = 'content/custom';

export default {
  createCustomContent(body) {
    return API.post(`${baseUri}`, body);
  },
  deleteCustomContent(syncguid, body) {
    return API.delete(`${baseUri}/${syncguid}`, body);
  },
  uploadVideo(url, video, options) {
    return axios.put(url, video, { headers: options });
  },
  updateVideo(syncguid, body) {
    return API.put(`${baseUri}/${syncguid}/video`, body);
  },
  getCustomContent(params) {
    return API.get(`${baseUri}`, params).then(res => {
      return {
        total: res.meta.page.total,
        cursor: res.meta.page.cursor,
        content: res.data.content.map(item => content.mapContent(item)),
        facets: res.data.facets,
      };
    });
  },
  getProfile(syncguid) {
    return API.get(`${baseUri}/${syncguid}`).then(res => {
      return content.mapContent(res);
    });
  },
  getThumbnail(syncguid) {
    return API.get(`${baseUri}/${syncguid}/image/poster`).then(res => res);
  },
  downloadThumbnail(syncguid, file) {
    return API.get(`${baseUri}/${syncguid}/image/poster/download/`, {
      title: file,
    }).then(res => {
      window.open(res, '_blank');
    });
  },
  putThumbnail(syncguid, file) {
    return API.put(`${baseUri}/${syncguid}/image/poster`, {
      type: file.type,
    }).then(url => {
      return axios.put(url, file, {
        headers: {
          'Content-Type': file.type,
        },
      });
    });
  },
  getSupportMaterials(syncguid) {
    return API.get(`${baseUri}/${syncguid}/materials`).then(res => res);
  },
  downloadSupportMaterial(syncguid, file) {
    return API.get(`${baseUri}/${syncguid}/materials/${file}`).then(res => {
      window.open(res, '_blank');
    });
  },
  deleteSupportMaterials(syncguid, files) {
    return API.delete(`${baseUri}/${syncguid}/materials`, files);
  },
  putSupportMaterial(syncguid, file) {
    const body = {
      file: file.name,
      type: file.type,
    };
    return API.put(`${baseUri}/${syncguid}/materials`, body).then(url => {
      return axios.put(url, file, {
        headers: {
          'Content-Type': file.type,
        },
      });
    });
  },
  getInteractions(syncguid) {
    return API.get(`${baseUri}/${syncguid}/interactions`).then(
      res => res.material,
    );
  },
  postInteractions(syncguid, body) {
    return API.post(`${baseUri}/${syncguid}/interactions`, body);
  },
  patchInteractions(syncguid, body) {
    return API.patch(`${baseUri}/${syncguid}/interactions`, body);
  },
  deleteInteractions(syncguid, body) {
    return API.delete(`${baseUri}/${syncguid}/interactions`, body);
  },
  getResources(syncguid) {
    return API.get(`${baseUri}/${syncguid}/resources`).then(res => res);
  },
  getCaptions(syncguid) {
    return API.get(`${baseUri}/${syncguid}/captions`).then(res => {
      const materials = Array.isArray(res.material) ? res.material : [];
      const englishCaptions = materials.find(caption => caption.language === 'en-US');
      return englishCaptions?.data ?? materials[0]?.data ?? [];
    });
  },
  postCaptions(syncguid, body) {
    return API.post(`${baseUri}/${syncguid}/captions`, body);
  },
  patchCaptions(syncguid, body) {
    return API.patch(`${baseUri}/${syncguid}/captions`, body);
  },
  deleteCaptions(syncguid) {
    return API.delete(`${baseUri}/${syncguid}/captions`);
  },
  getQuiz(syncguid) {
    return API.get(`${baseUri}/${syncguid}/quiz`);
  },
  patchProfile(syncguid, body) {
    body = JSON.parse(JSON.stringify(body));
    Object.keys(body).forEach(key => {
      if (key.includes('date')) {
        body[key] = body[key] !== null ? moment(body[key]).valueOf() : null;
      }
    });
    return API.patch(`${baseUri}/${syncguid}`, body);
  },
  postQuiz(syncguid, body) {
    return API.post(`${baseUri}/${syncguid}/quiz`, body);
  },
  patchQuiz(syncguid, body) {
    return API.patch(`${baseUri}/${syncguid}/quiz`, body);
  },
  deleteQuiz(syncguid) {
    return API.delete(`${baseUri}/${syncguid}/quiz`);
  },
  postQuestions(syncguid, body) {
    return API.post(`${baseUri}/${syncguid}/quiz/questions`, body);
  },
  patchQuestions(syncguid, body) {
    return API.patch(`${baseUri}/${syncguid}/quiz/questions`, body);
  },
  deleteQuestions(syncguid, questions) {
    return API.delete(`${baseUri}/${syncguid}/quiz/questions`, questions);
  },
};
